module.exports = __webpack_public_path__ + "img/student_2.2b82fac8.png";